import { Controller } from "react-hook-form";
import { Box, Paper, Stack, Text } from "@mantine/core";
import { Button } from "@onengine/component-library";
import type { ControlledFieldProps } from "../types";
import styles from "./Signature.module.scss";

export function ControlledSignature({
  name,
  control,
  error,
  onSig,
  placeholder,
}: Omit<ControlledFieldProps, "clearErrors"> & {
  onSig: (id: string) => void;
  placeholder?: string;
}) {
  return (
    <Controller
      name={name}
      control={control}
      defaultValue=""
      render={({ field }) =>
        typeof field.value === "string" && field.value ? (
          <Stack className={styles.signatureStack}>
            <img src={field.value} alt="Signature" className={styles.signatureImage} />
            <Button variant="text-primary" size="small" onClick={() => onSig(name)}>
              Edit signature
            </Button>
          </Stack>
        ) : field.value && typeof field.value === "object" ? (
          <Stack className={styles.signatureStack}>
            <Text size="sm">Signature saved</Text>
            <Button variant="text-primary" size="small" onClick={() => onSig(name)}>
              Sign again
            </Button>
          </Stack>
        ) : (
          <Box>
            <Paper
              p="lg"
              radius="md"
              className={error ? styles.signatureDropzoneError : styles.signatureDropzone}
              role="button"
              tabIndex={0}
              onClick={() => onSig(name)}
              onKeyDown={(event) => {
                if (event.key !== "Enter" && event.key !== " ") return;
                event.preventDefault();
                onSig(name);
              }}
            >
              <Text
                size="sm"
                className={error ? styles.signatureDropzoneTextError : styles.signatureDropzoneText}
              >
                {placeholder || "Tap or click to sign"}
              </Text>
            </Paper>
            {error && (
              <Text size="xs" className={styles.signatureFieldError}>
                {error}
              </Text>
            )}
          </Box>
        )
      }
    />
  );
}
